/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { inject, InjectionToken } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  NavigationExtras,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

export interface DeepLink {
  commands: any[];
  extras?: NavigationExtras;
}

export interface DeepLinkFactory {
  (route: ActivatedRouteSnapshot): Maybe<DeepLink>;
}

export const DEEP_LINK_FACTORY = new InjectionToken<DeepLinkFactory>('DeepLinks');

function navigateToDeepLink(route: ActivatedRouteSnapshot): boolean {
  const router = inject(Router);
  const deepLinkFactory = inject(DEEP_LINK_FACTORY);
  const deepLink = deepLinkFactory(route);

  if (deepLink) {
    router.navigate(deepLink.commands, deepLink.extras);
  } else {
    throw new Error(`Deep link cannot be found for url '${route.url}'`);
  }

  return false;
}

export const deepLinkActivateGuard: CanActivateFn = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean => {
  return navigateToDeepLink(route);
};

export const deepLinkActivateChildGuard: CanActivateChildFn = (childRoute: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean => {
  return navigateToDeepLink(childRoute);
};
